
<component
  :is="as"
  class="pro-label"
  v-bind="$attrs"
  v-on="$listeners"
  v-tooltip="{ content: tooltip, delay: { show: 1000, hide: 100 }, placement: 'bottom' }"
>
  <slot v-if="$slots.default" />
  <span v-else>Pro</span>
</component>
